import React from 'react';

const Backend = () => {
  return (
    <div className="skills__content">

      <h3 className="skills__title">Back-end</h3>

      <div className="skills__box">
        
        <div className="skills_group">

          <div className="skills__data">

            <i className='bx bx-badge-check' ></i>

            <div>

              <h3 className="skills__name">PHP</h3>
              <span className="skills_level">Intermediário</span>
            
            </div>

          </div>

          <div className="skills__data">

            <i className='bx bx-badge-check' ></i>

            <div>

              <h3 className="skills__name">MySQL</h3>
              <span className="skills_level">Básico</span>

            </div>

          </div>

          <div className="skills__data">

            <i className='bx bx-badge-check' ></i>

            <div>

              <h3 className="skills__name">Node js</h3>
              <span className="skills_level">Básico</span>

            </div>

          </div>
        
        </div>


      </div>

    </div>
  )
}

export default Backend;
